import React from 'react';
import { isLink, MetaEntry, renderRule, StructuredText as DatoCmsStructuredText } from 'datocms-structured-text-utils';
import { StructuredText as DatoCmsStructuredTextComponent } from 'react-datocms';
import Link from '../link/link';
import { DatoCmsPage } from '../../schema/datocms/page';
import ContactLink, { ContactLinkProps } from '../contact-link/contact-link';
import { InternalPageReference } from '../../schema/datocms';
import { ComponentTypeNames } from '../../schema';

export interface StructuredTextProps {
    data: DatoCmsStructuredText
    className?: string;
}

const StructuredText = ({ className, data }: StructuredTextProps & React.HTMLAttributes<HTMLDivElement>): React.ReactElement => {

    // Meta transformer adapted from here
    // https://github.com/datocms/structured-text/blob/main/packages/generic-html-renderer/src/index.ts
    const metaTransformer = (meta?: MetaEntry[]): { [key: string]: string } => {
        return meta ?
            meta.reduce(
                (acc: { [key: string]: string }, curr: { id: string, value: string }) => {
                    acc[curr.id] = curr.value;
                    return acc;
                }, {}) :
            { };
    };

    return (
        <div className={className}>
            <DatoCmsStructuredTextComponent
                data={data}
                renderInlineRecord ={({ record }) => {
                    switch(record.__typename) {
                        case 'DatoCmsContact':
                            return <ContactLink {...record as unknown as ContactLinkProps} className="underline" />;
                        default:
                            // TODO: Add non-production visual warning component
                            console.warn('Unsupported inline record:', record.__typename);
                            return null;
                    }
                }}
                renderLinkToRecord={({ record, children, transformedMeta }) => {
                    switch(record.__typename) {
                        case ComponentTypeNames.PAGE:
                            const internalRef: InternalPageReference = {
                                __typename: ComponentTypeNames.PAGE,
                                slug: (record as Partial<DatoCmsPage>).slug || ''
                            };
                            return <Link {...transformedMeta} internalPageReference={internalRef} className="underline">{children}</Link>;
                        default:
                            console.warn('Unsupported record link:', record.__typename);
                            return null;
                    }
                }}
                customRules={[
                    renderRule(
                        isLink,
                        ({ adapter: { renderNode }, node, children, key }) => {
                            return renderNode('a', { key, className: 'underline', href: node.url, rel: 'noopener noreferrer', ...metaTransformer(node.meta) }, children);
                        }
                    )
                ]} />
        </div>
    );
};

export default StructuredText;
